import { render, staticRenderFns } from "./sunburst.vue?vue&type=template&id=0d381d91&scoped=true&"
import script from "./sunburst.vue?vue&type=script&lang=js&"
export * from "./sunburst.vue?vue&type=script&lang=js&"
import style0 from "./sunburst.vue?vue&type=style&index=0&id=0d381d91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d381d91",
  null
  
)

export default component.exports